var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validation-error cl-error h6"},[_vm._v("\n  DONT USE THERE WILL BE CHANGES IN API\n")])}
var staticRenderFns = []

export { render, staticRenderFns }